import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { NotificationsContainer } from '../../../containers/notifications/notifications';
import { MessageBoxLayout2 } from '../message-box-layout/message-box-layout';
import Modal from '../modal/modal';
import { NOTIFICATION_PLACEMENT } from '../notifications/notifications.constants';
import { modalClosed, modalShown } from './modal-message.actions';

import styles from './modal-message.scss';
import { ButtonProps } from '@wix/design-system';

export const getModalComponent = () => {
  return Modal;
};

interface OwnProps {
  dataHook?: string;
  children: React.ReactNode;
  contentLabel?: string;
  title: React.ReactNode;
  confirmText?: React.ReactNode;
  cancelText?: React.ReactNode;
  withForm?: boolean;
  isOpen?: boolean;
  noPadding?: boolean;
  hideFooter?: boolean;
  scrollable?: boolean;
  width?: string;
  theme?: string;
  useModalButtons?: boolean;
  isPlainModal?: boolean;
  primaryButtonProps?: ButtonProps;

  onSubmit?(): void;

  onCancel?(): void;

  onAfterOpen?(): void;

  onClose?(): void;

  modalClosed?(): void;

  modalShown?(): void;
}

interface DispatchProps {
  modalShown(): void;
  modalClosed(): void;
}

type Props = OwnProps & DispatchProps;

class ModalMessageComponent extends React.Component<Props> {
  public static defaultProps = {
    title: '',
    contentLabel: '',
    confirmText: 'OK',
    cancelText: 'Cancel',
    withForm: true,
    isOpen: true,
    noPadding: false,
    useModalButtons: true,
    isPlainModal: false,
  };

  public UNSAFE_componentWillReceiveProps(nextProps: OwnProps) {
    if (nextProps.isOpen !== this.props.isOpen && !nextProps.isOpen) {
      nextProps.modalClosed && nextProps.modalClosed();
    }
  }

  public componentWillUnmount() {
    this.props.modalClosed();
  }

  public onAfterOpen() {
    const { modalShown, onAfterOpen }: OwnProps = this.props;

    modalShown();

    if (onAfterOpen) {
      onAfterOpen();
    }
  }

  public handleFormSubmit(e) {
    const { onSubmit } = this.props;

    e.preventDefault();

    if (onSubmit) {
      onSubmit();
    }
  }

  public renderChildren(children, contentWrapperClassNames, withForm) {
    return (
      <div className={contentWrapperClassNames}>
        <div className={styles.notifications}>
          <NotificationsContainer placement={NOTIFICATION_PLACEMENT.MODAL} />
        </div>
        {withForm ? this.renderModalContent() : children}
      </div>
    );
  }

  public renderModalContent() {
    const { children, onSubmit }: OwnProps = this.props;

    if (onSubmit) {
      return (
        <form onSubmit={this.handleFormSubmit.bind(this)} autoComplete="off">
          {children}
        </form>
      );
    }

    return children;
  }

  public render() {
    const {
      children,
      contentLabel,
      withForm,
      isOpen,
      onClose,
      onCancel,
      onSubmit,
      noPadding,
      useModalButtons,
      isPlainModal,
      ...props
    }: OwnProps = this.props;

    const ModalComponent = getModalComponent();
    const contentWrapperClassNames = classNames(styles.contentWrapper, {
      [styles.noPadding]: noPadding,
    });

    return (
      <ModalComponent
        isOpen={isOpen}
        onRequestClose={onClose || onCancel}
        contentLabel={contentLabel}
        shouldCloseOnOverlayClick
        onAfterOpen={this.onAfterOpen.bind(this)}
        closeTimeoutMS={0}
      >
        {isPlainModal ? (
          withForm ? (
            this.renderModalContent()
          ) : (
            this.renderChildren(children, contentWrapperClassNames, withForm)
          )
        ) : (
          <div data-hook="message-box-layout">
            <MessageBoxLayout2
              primaryButtonText={useModalButtons ? props.confirmText : null}
              secondaryButtonText={useModalButtons ? props.cancelText : null}
              primaryButtonOnClick={useModalButtons ? onSubmit : null}
              secondaryButtonOnClick={useModalButtons ? onCancel : null}
              onCloseButtonClick={onClose ? onClose : null}
              primaryButtonProps={
                useModalButtons ? props.primaryButtonProps : null
              }
              title={props.title}
              width={props.width ? props.width : '30vw'}
              overflowY="none"
              {..._.omit(props, ['onAfterOpen'])}
            >
              {this.renderChildren(
                children,
                contentWrapperClassNames,
                withForm,
              )}
            </MessageBoxLayout2>
          </div>
        )}
      </ModalComponent>
    );
  }
}

const mapDispatchToProps = {
  modalShown,
  modalClosed,
};

export const ModalMessage = connect<void, DispatchProps, OwnProps>(
  null,
  mapDispatchToProps,
)(ModalMessageComponent);
